export default {
  type: 'document',
  name: 'removeRestoreActionTest',
  title: 'Remove Restore Action',
  fields: [
    {
      type: 'string',
      name: 'title',
      title: 'Title',
    },
  ],
}
